module.exports = __webpack_public_path__ + "img/features_img_pengaturan.1d3571c3.png";